import React from 'react';
import { getQuestionsByContext } from '../../data/quickChatQuestions';

/**
 * QuickChatQuestions Component
 * แสดงคำถามแนะนำเมื่อเริ่มแชท
 */
const QuickChatQuestions = ({ product, store, onQuestionClick }) => {
  const questions = getQuestionsByContext(product, store);

  if (!questions || questions.length === 0) {
    return null;
  }

  const handleQuestionClick = (question) => {
    if (onQuestionClick) {
      onQuestionClick(question.question);
    }
  };

  return (
    <div className="p-4 bg-gray-50 rounded-lg mb-4">
      <div className="text-sm font-medium text-gray-700 mb-3">
        💬 คำถามแนะนำ:
      </div>
      <div className="grid grid-cols-2 gap-2">
        {questions.map(question => (
          <button
            key={question.id}
            onClick={() => handleQuestionClick(question)}
            className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition text-left text-sm"
          >
            <span className="mr-2">{question.icon}</span>
            {question.question}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickChatQuestions;







